import { LSError } from '../util/LSError.interface';

export class UploadDocumentsError extends Error implements LSError {
  message: string;
  title: string;

  constructor() {
    super();
    this.title = 'Upload Documents Error';
    this.message = 'There was an error uploading your documents, please contact support if the error persists';
  }
}
